import * as React from 'react';
import { List, EditButton, Datagrid, TextField, Filter, TextInput } from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
    </Filter>
);

const SegmentList = () => {
    const { isUpdatable, isDeletable, isWritable } = useIsPermission('SEGMENTS');
    return (
        <div>
            <List
                filters={<ListFilter />}
                actions={<PermissionBasedActions isWritable={isWritable} />}
                queryOptions={{
                    refetchOnReconnect: false,
                    refetchOnWindowFocus: false,
                }}
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source="name" sortable={false} />
                    <TextField source="module" sortable={false} />
                    <FormattedDateTimeField source="createdAt" sortable={false} />
                    {isUpdatable && <EditButton />}

                    {isDeletable && <ConfirmDeleteButton />}
                </Datagrid>
            </List>
        </div>
    );
};
export default SegmentList;
